import React from 'react';
import { Redirect } from 'react-router-dom';
import { ROUTES } from '../../../constants';
import { getFormsDetailFallbackPath, useFormsAccess } from '../../../hooks/useFormsAccess';

const FormsAccessGate = ({ children }) => {
  const { isResolved, hasSubscriptionPermission, canViewForms, canInteractWithForms } = useFormsAccess();

  if (!isResolved) {
    return children;
  }

  if (!hasSubscriptionPermission || !canViewForms) {
    return <Redirect to={ROUTES.ROUTE_DASHBOARD.path} />;
  }

  if (!canInteractWithForms) {
    return <Redirect to={getFormsDetailFallbackPath()} />;
  }

  return children;
};

export default FormsAccessGate;
